import {
  card,
  cardHeader,
  defaultFont,
  orangeCardHeader,
  greenCardHeader,
  redCardHeader,
  blueCardHeader,
  purpleCardHeader,
  grayCardHeader,
  cardActions,
  grayColor,
  warningColor,
  dangerColor,
  successColor,
  infoColor,
  primaryColor,
  roseColor
} from "./globalStyles";

const chartCardStyle = {
  card,
  cardHeader: {
    ...cardHeader,
    padding: "0",
    // minHeight: "80px",
    paddingTop: "20px",
    paddingBottom: "10px",
    ...defaultFont
  }, 
  cardPlainHeader: {
    marginLeft: 0,
    marginRight: 0
  },
  cardTitle: {
    color: "black",
    marginTop: "0",
    marginBottom: "5px",
    ...defaultFont,
    fontSize: "1.125em"
  },
  cardSubtitle: {
    ...defaultFont,
    marginBottom: "0",
    color: 'black',
    margin: "0 0 10px"
  },

  sparkCardHeader: {
    ...cardHeader,
    padding: "0",
    minHeight: "100px",
    paddingTop: "20px",
    paddingBottom: "0px",
    ...defaultFont
  },
  orangeCardHeader,
  greenCardHeader,
  redCardHeader,
  blueCardHeader,
  purpleCardHeader,
  grayCardHeader,
  cardContent: {
    padding: "15px 20px",
  },

  sparkCardContent: {
    padding: "15px 20px",
    textAlign: 'center',
    paddingBottom: '0px',
    minHeight: '73px',
  },
  cardTitle: {
    marginTop: "0",
    marginBottom: "5px",
    
    ...defaultFont,
    fontSize: "1.175em"
  },
  sparkCardTitle: {
    marginTop: "-20px",
    marginBottom: "5px",
    ...defaultFont,
    fontSize: "0.5em",
    textAlign: 'center',
    fontWeight: '400'
  },

  sparkCardCategory: {
    marginBottom: "0",
    color: grayColor,
    ...defaultFont,
    fontSize: "1.8em"
  },
  cardCategory: {
    marginBottom: "0",
    color: grayColor,
    ...defaultFont,
    fontSize: "0.9em"
  },
  cardActions: {
    ...cardActions,
    padding: "0!important"
  },
  cardStats: {
    lineHeight: "22px",
    color: grayColor,
    fontSize: "12px",
    display: "inline-block",
    margin: "0!important"
  },
  cardStatsIcon: {
    position: "relative",
    top: "4px",
    width: "16px",
    height: "16px"
  },
  warningCardStatsIcon: {
    color: warningColor
  },
  primaryCardStatsIcon: {
    color: primaryColor
  },
  dangerCardStatsIcon: {
    color: dangerColor
  },
  successCardStatsIcon: {
    color: successColor
  },
  infoCardStatsIcon: {
    color: infoColor
  },
  roseCardStatsIcon: {
    color: roseColor
  },
  grayCardStatsIcon: {
    color: grayColor
  },
  
  cardStatsLink: {
    color: primaryColor,
    textDecoration: "none",
    ...defaultFont
  }
};

export default chartCardStyle;



// WEBPACK FOOTER //
// ./src/assets/chardCardStyle.jsx